<template>
    <div class="payment-method-group">
        <div
            class="title"
            :class="type"
        >
            <h2 v-if="type==='recommended'">
                {{$t('subscription.recommended')}}
            </h2>
            <h2 v-else-if="type==='try-again'">
                {{$t('subscription.try_again')}}
            </h2>
        </div>
        <div class="payment-method-options">
            <div
                v-for="paymentMethod in paymentMethods"
                :key="paymentMethod.id"
            >
                <PaymentMethodCardOption
                    :payment-method="paymentMethod"
                    :selected-payment-method="selectedPaymentMethod"
                    @click="setPaymentMethod"
                />
            </div>
        </div>
    </div>
</template>
<script>
import PaymentMethodCardOption from "./PaymentMethodCardOption"

export default {
    name: 'PaymentMethodGroup',
    components: {PaymentMethodCardOption},
    props: {
        paymentMethods: {},
        selectedPaymentMethod: {},
        type: {}
    },
    methods: {
        setPaymentMethod(paymentMethod){
            this.$emit('click', paymentMethod);
        },
    },
}
</script>
<style scoped lang="scss">
.payment-method-group{
    margin-top: 30px;
    
    .title{
        text-align: center;
        font-family: arial, helvetica;
        text-transform: uppercase;
        
        &.recommended{}
        &.try-again{
            font-size: .6em;
        }
        &.others{}
    }
    
    .payment-method-options{
        display: flex;
        justify-content: space-around;
    }
}
</style>